import {Observable, Subscription} from 'rxjs';

import IMedia      from '../../../../Player/Interfaces/IMedia';
import IMediaStore from '../Interfaces/IMediaStore';

const subscribeToConsumerMedia = (
    consumerMedia$: Observable<IMedia>,
    mediaStore: IMediaStore
): Subscription =>
    consumerMedia$
        .subscribe(nextMedia => mediaStore.actions.load(nextMedia));

export default subscribeToConsumerMedia;